import { render } from "./DamagedProducts.vue?vue&type=template&id=49b5e6d0&scoped=true"
import script from "./DamagedProducts.vue?vue&type=script&lang=js"
export * from "./DamagedProducts.vue?vue&type=script&lang=js"

import "./DamagedProducts.vue?vue&type=style&index=0&id=49b5e6d0&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b5e6d0"]])

export default __exports__